import { TREATMENT_AUTHORITY_RESPONSE_KEY } from "./treatmentApiConstants";

const responseValues = (value) => (
  Array.isArray(value) ? value : value === undefined || value === null || value === "" ? [] : [value]
);

export const selectedProgramIds = (questionnaire, responses) => {
  const selected = new Set();
  (questionnaire?.questions || [])
    .filter((question) => question.question_type === "product_selection")
    .forEach((question) => {
      const responseKey = [question.id, question.source_id, question.release_node_id]
        .find((key) => key && Object.prototype.hasOwnProperty.call(responses || {}, key));
      const values = responseValues(responseKey ? responses[responseKey] : undefined);
      if (values.length && question.program_id) {
        selected.add(String(question.program_id));
      }
      values.forEach((value) => {
        if (value && typeof value === "object" && value.program_id) {
          selected.add(String(value.program_id));
          return;
        }
        const selectedValue = String(value || "");
        const choices = question.answer_choices || question.checkout_config?.products || [];
        const choice = choices.find((candidate) => [
          candidate?.option_id,
          candidate?.product_id,
          candidate?.value,
          candidate?.id,
        ].some((candidateId) => String(candidateId || "") === selectedValue));
        if (choice?.program_id) selected.add(String(choice.program_id));
      });
    });
  return selected;
};

export const selectedLabProgramIds = (questionnaire, responses) => {
  const recommended = responseValues(
    responses?.[TREATMENT_AUTHORITY_RESPONSE_KEY.recommendedProgramIds],
  )
    .map((program) => String(
      program && typeof program === "object" ? program.program_id || program.id : program,
    ).trim())
    .filter(Boolean);
  return recommended.length ? new Set(recommended) : selectedProgramIds(
    questionnaire,
    responses,
  );
};

